import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { AssetTransferByDepartmentDetail } from './AssetTransferByDepartmentDetail/AssetTransferByDepartmentDetail'
import { AssetTransferByDepartmentForm } from './AssetTransferByDepartmentForm/AssetTransferByDepartmentForm'
import { AssetTransferByDepartmentMain } from './AssetTransferByDepartmentMain'

const assetTransferByDepartmentRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/asset-transfer-by-department/filter',
    },
    component: (
      <AdvancedFilter
        mode="assets-change"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/asset-transfer-by-department',
    },
    component: <AssetTransferByDepartmentMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/asset-transfer-by-department/add',
    },
    component: (
      <AssetTransferByDepartmentForm formMode="add" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/asset-transfer-by-department/:AssetTransferByDepartmentID/edit',
    },
    component: <AssetTransferByDepartmentForm formMode="edit" />,
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/asset-transfer-by-department/:AssetTransferByDepartmentID/resubmit',
    },
    component: <AssetTransferByDepartmentForm formMode="resubmit" />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/asset-transfer-by-department/:AssetTransferByDepartmentID/detail',
    },
    component: <AssetTransferByDepartmentDetail />,
  },
]

export default assetTransferByDepartmentRoutes
